import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCPOocqQ--qJ8zPZzO1jnTxCyjFMSN-AGo",
    authDomain: "grundriss-ai.firebaseapp.com",
    projectId: "grundriss-ai",
    storageBucket: "grundriss-ai.firebasestorage.app",
    messagingSenderId: "49316525756",
    appId: "1:49316525756:web:d1a94f79033279abfe82b9",
    measurementId: "G-YEN1C7TXDD"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

if (process.env.VUE_APP_USE_FIREBASE_EMULATOR === 'true') {
    const emulatorOrigin = (() => {
        if (process.env.VUE_APP_FIREBASE_EMULATOR_ORIGIN) {
            return process.env.VUE_APP_FIREBASE_EMULATOR_ORIGIN;
        }

        const protocol = process.env.VUE_APP_FIREBASE_EMULATOR_PROTOCOL || 'http';
        const host =
            process.env.VUE_APP_FIREBASE_EMULATOR_HOST ||
            (typeof window !== 'undefined' ? window.location.hostname : 'localhost');
        const port = process.env.VUE_APP_FIREBASE_EMULATOR_PORT || '9099';
        return `${protocol}://${host}:${port}`;
    })();

    connectAuthEmulator(auth, emulatorOrigin, { disableWarnings: true });
}

export { auth }; 
